if (!customElements.get('embroidery-name')) {

  class EmbroideryName extends HTMLElement {
    connectedCallback() {
      this.fieldset = document.querySelector(`#variant-selects-${this.dataset.section} [data-embroidery-option]`);
      this.input = this.querySelector('[data-embroidery-input]');
      this.preview = this.querySelector('[data-embroidery-preview]');
      this.count = this.querySelector('[data-embroidery-count]');
      if (!this.fieldset || !this.input) return;

      this.select = this.fieldset.querySelector('select');
      this.offValue = this.fieldset.dataset.offValue;
      this.toggles = this.fieldset.querySelectorAll('input[type="radio"]');

      this.toggles.forEach((toggle) => toggle.addEventListener('change', this.onToggle.bind(this)));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('change', () => {
        this.input.value = this.input.value.trim().replace(/\s+/g, ' ');
        this.updatePreview();
      });

      this.setActive(this.select.value !== this.offValue);
    }

    onToggle(event) {
      const isOn = event.target.value === 'on';
      this.select.value = isOn ? this.getEmbroideryValue() : this.offValue;
      this.setActive(isOn);
      if (isOn) this.input.focus({ preventScroll: true });
    }

    onInput() {
      const clean = this.input.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ .'-]/g, '').replace(/^[^A-Za-zÀ-ÖØ-öø-ÿ]+/, '');
      if (clean !== this.input.value) this.input.value = clean;

      this.updatePreview();

      if (!this.isActive) return;
      const value = this.getEmbroideryValue();
      if (value !== this.select.value) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    getEmbroideryValue() {
      const values = Array.from(this.select.options)
        .map((option) => option.value)
        .filter((value) => value !== this.offValue);
      const initial = this.input.value.trim()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .charAt(0).toUpperCase();

      const candidates = [initial, this.select.value, ...values].filter((value) => values.includes(value));
      return candidates.find((value) => this.isAvailable(value)) || candidates[0];
    }

    isAvailable(value) {
      const variantSelects = this.fieldset.closest('variant-selects');
      if (!variantSelects || !variantSelects.getVariantData || !variantSelects.options) return true;

      const index = Array.from(variantSelects.querySelectorAll('fieldset')).indexOf(this.fieldset);
      const options = variantSelects.options.slice();
      options[index] = value;

      const variant = variantSelects.getVariantData().find((item) => {
        return item.options.every((option, i) => option === options[i]);
      });
      return Boolean(variant && variant.available);
    }

    setActive(isOn) {
      this.isActive = isOn;
      this.hidden = !isOn;
      this.input.disabled = !isOn;
      this.input.required = isOn;
      this.toggles.forEach((toggle) => {
        toggle.checked = (toggle.value === 'on') === isOn;
      });
      this.updatePreview();
    }

    updatePreview() {
      const name = this.input.value.trim();
      if (this.count) this.count.textContent = this.input.value.length;
      if (!this.preview) return;
      this.preview.textContent = name || this.dataset.placeholder;
      this.preview.classList.toggle('is-empty', !name);
    }
  }
  customElements.define('embroidery-name', EmbroideryName);
}
